export function krsValidator($el, required) {
  if (!$el.val()) {
    return true;
  }
  const pattern = /^\d{10}$/;
  return pattern.test($el.val());
}
Foundation.Abide.defaults.validators["krs"] = krsValidator;
